import { render, StrictMode, WPElement } from "@wordpress/element";
import { Disclosure, Transition } from '@headlessui/react'

function classNames(...classes) {
  return classes.filter(Boolean).join(' ')
}

export type Entry = {
  label: {
    className?: string,
    content: string
  },
  content: {
    className?: string,
    content: string | WPElement
  },
  defaultOpen?: boolean,
  className?: string
};

export function Accordion(props: {className?: string, list: Entry[]}) {

  return (
    <dl className={props.className}>
      {props.list.map((e, k) => (
        <Disclosure as="div" key={k} className={e.className} defaultOpen={e.defaultOpen}>
          {({ open }) => (
            <>
              <dt className="text-lg">
                <Disclosure.Button className="text-left w-full flex justify-between items-start text-gray-400">
                  <span className={e.label.className}>{e.label.content}</span>
                  <span className="ml-6 h-7 flex items-center">
                    <i className={classNames(open ? "fa-chevron-up" : "fa-chevron-down", "fa-solid")} aria-hidden="true"></i>
                  </span>
                </Disclosure.Button>
              </dt>
              <Transition
                  enter="transition duration-100 ease-out"
                  enterFrom="transform scale-95 opacity-0"
                  enterTo="transform scale-100 opacity-100"
                  leave="transition duration-75 ease-out"
                  leaveFrom="transform scale-100 opacity-100"
                  leaveTo="transform scale-95 opacity-0"
                >
                <Disclosure.Panel as="dd" className={e.content.className}>
                  {e.content.content}
                </Disclosure.Panel>
              </Transition>
            </>
          )}
        </Disclosure>
      ))}
    </dl>
  )
}

export const SwtAccordion = {
  connectedCallback(elm: HTMLElement) {
    const list: Entry[] = [];

    elm.querySelectorAll("template").forEach(e => {
      let templateContent = e.content;
      //const node = templateContent.cloneNode(true) as unknown as any;

      const entry = {
        className: e.getAttribute("class"),
        defaultOpen: e.hasAttribute("data-default-open")  && e.getAttribute("data-default-open") == "1"
      } as Entry;

      const slots = templateContent.querySelectorAll("slot");
      if (slots.length > 0) {
        templateContent.querySelectorAll("slot").forEach(slot => {
          const name = slot.getAttribute("name");
          if (name == "dt") {
            entry.label = {
              className: slot.getAttribute("class"),
              content: slot.innerHTML
            };
          } else if (name == "dd") {
            entry.content = {
              className: slot.getAttribute("class"),
              content: <div dangerouslySetInnerHTML={{__html: slot.innerHTML }}></div>
            };
          }
        });
      } else {
        entry.label = {
          content: e.getAttribute("data-label")
        };
        entry.content = {
          content: e.innerHTML
        };
      }

      list.push(entry);
      /*
      console.log(e.slot);
      const label = e.getAttribute("data-label");
      const content = e.innerHTML;
      const defaultOpen = e.hasAttribute("data-default-open")  && e.getAttribute("data-default-open") == "1";

      list.push({
        label: label,
        content: content,
        defaultOpen: defaultOpen
      });
      */
    });

    render(
      <StrictMode>
        <Accordion list={list} />
      </StrictMode>,
      elm
    );
  }
}
